import React from 'react';
import { styled } from 'linaria/react';
import CategoryLink from '@jetshop/ui/CategoryLink';
import { useContext } from 'react';
import SiteContentContext from '../SiteContent/SiteContentContext';
import { convertPropsToObject } from '../ContentRender/ContentRender';

const Wrapper = styled.div`
  padding-top: 4rem;
  text-align: center;
  h3 {
    margin-bottom: 1rem;
  }
  ul {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    li {
      margin: 5px;
      button {
        padding: 5px 15px;
        background: #eee;
      }
    }
  }
`;

const SeoLinks = ({ category }) => {
  const links = category?.data?.items.filter(
    (item) => item.type === 'category-links'
  )[0];
  const { categoryBottomSeoTitle } = useContext(SiteContentContext);

  if (!links) return null;

  return (
    <Wrapper>
      <h3>{categoryBottomSeoTitle}</h3>
      <ul>
        {links.children.map((cat, index) => {
          const props = convertPropsToObject(cat);
          const category = props.category?.value;
          const text = props.linkText?.value;
          if (!category) return null;
          return (
            <li key={index}>
              <button>
                <CategoryLink category={category}>
                  {text ? text : category?.name}
                </CategoryLink>
              </button>
            </li>
          );
        })}
      </ul>
    </Wrapper>
  );
};

export default SeoLinks;
